import React, { Component } from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import Image from '../../helpers/Image.jsx';
import gullfoss from './images/gullfoss.png';
import './Map.css';

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
    fontSize: state.fontSize,
  }
}

class Map extends Component {
  render() {

    const {
      fonts,
    } = this.props;


    const {
      primary,
      secondary
    } = fonts;

    const styles = {
      primaryFont: {
        fontFamily: primary.name,
      },
      secondaryFont: {
        fontFamily: secondary.name,
      },
    }

    return (
      <Paper
        zDepth={1}
        className="phone-wrapper">
        <div className="map-header">
          <Image src={gullfoss} className="map-image" />
        </div>
        <div className="map-body">
          <div className="map-header-text"
            style={styles.primaryFont}>
            Gullfoss Waterfall
          </div>
          <div className="map-description-text"
            style={styles.secondaryFont}>
            Our first stop was Gullfoss. Gullfoss Waterfall is one of Iceland’s most popular tourist attractions.

            While many would not think of travelling to Iceland during this cold time of year when there’s only 4-5 hours of daylight, seeing Gullfoss Waterfall in winter is something quite spectacular to behold.

            Upon arrival at Gullfoss, stop for a moment to take in the surrounding snow-covered landscape. Iceland is like no other place on earth; it’s simply beautiful.
          </div>
        </div>
        <div className="map-actions">
          <div className="map-first-action"
            style={styles.primaryFont}>
            See on map
          </div>
          <div className="map-second-action"
            style={styles.primaryFont}>
            Book a trip
          </div>
        </div>
      </Paper>
    )
  }
}

export default Map = connect(mapStateToProps, undefined)(Map);



// WEBPACK FOOTER //
// ./src/components/generator/elements/Map.jsx